import MediaInserterSelector from '@intercom/embercom-composer/components/media-inserter-selector';
export default MediaInserterSelector;
